import { createSlice } from "@reduxjs/toolkit";

const initialConfigState = {
    APP_ID: null,
    SEARCH_KEY: null,
    SEARCH_INDEX: null,
    SEARCH_INDEX_QUERY_SUGGESTIONS: null,
    SEARCH_PRICE_ASC_INDEX: null,
    SEARCH_PRICE_DESC_INDEX: null,
    SEARCH_SHIPPINGTIMEINDAYS_ASC_INDEX: null,
    SEARCH_SHIPPINGTIMEINDAYS_DESC_INDEX: null,
    DEBOUNCE_TIME_MS: null,
    CHARACTERS_TO_TRIGGER: null,
    S_USER_TOKEN: null,
    BUTTON_TEXT_CONFIG: null,
    BUTTON_TEXT_ADD: null,
};

const configSlice = createSlice({
    name: "config",
    initialState: initialConfigState,
    reducers: {
        initConfig(state, action) {
            state.APP_ID = action.payload.APP_ID;
            state.SEARCH_KEY = action.payload.SEARCH_KEY;
            state.SEARCH_INDEX = action.payload.SEARCH_INDEX;
            state.SEARCH_PRICE_ASC_INDEX =
                action.payload.SEARCH_PRICE_ASC_INDEX;
            state.SEARCH_PRICE_DESC_INDEX =
                action.payload.SEARCH_PRICE_DESC_INDEX;
            state.SEARCH_SHIPPINGTIMEINDAYS_ASC_INDEX =
                action.payload.SEARCH_SHIPPINGTIMEINDAYS_ASC_INDEX;
            state.SEARCH_SHIPPINGTIMEINDAYS_DESC_INDEX =
                action.payload.SEARCH_SHIPPINGTIMEINDAYS_DESC_INDEX;
            state.SEARCH_INDEX_QUERY_SUGGESTIONS =
                action.payload.SEARCH_INDEX_QUERY_SUGGESTIONS;
            state.DEBOUNCE_TIME_MS = action.payload.DEBOUNCE_TIME_MS;
            state.CHARACTERS_TO_TRIGGER = action.payload.CHARACTERS_TO_TRIGGER;
            state.INSIGHTS_USER_TOKEN = action.payload.INSIGHTS_USER_TOKEN;
            state.BUTTON_TEXT_CONFIG = action.payload.BUTTON_TEXT_CONFIG;
            state.BUTTON_TEXT_ADD = action.payload.BUTTON_TEXT_ADD;
        },
    },
});
export default configSlice;
